export default "__VITE_ASSET__BJX3hZRM__"